import React, { useState, useEffect, useRef } from 'react';
import './style.css';

const reviews = [
  { name: "German H",        time: "Hace 3 meses",  text: "Le encargamos un trabajo para una obra, terminamos pidiéndole varios más. Tienen un excelente precio y trabajan a tiempo. Muy recomendable el Sr. Sergio." },
  { name: "Mariela Maffioli",time: "Hace 6 meses",  text: "La mesada quedó hermosa. Y la atención muy buena, siempre atentos y respondiendo a todas las inquietudes. Muchas gracias!" },
  { name: "Valeria Nieves",  time: "Hace un año",   text: "Muy buen servicio y excelente calidad de mesada. Buena atención y buenos presupuestos de acorde en calidad y precio. Muy recomendables." },
  { name: "Hector Terzi",    time: "Hace 5 años",   text: "Excelente atención, me consiguieron el mármol que quería en mejor precio que en otro lado. Entrega en tiempo y forma, como lo pactado. Recomendable 100%." },
  { name: "Gustavo Rubio",   time: "Hace 5 años",   text: "Excelente atención! Muy buena predisposición para todo y precios accesibles." },
  { name: "Leonardo Rosviar",time: "Hace 6 años",   text: "Me cortaron la mesada a medida bárbaro, trabajan muy bien. Carlos nos atendió de maravilla y muy buenos precios. Recomiendo y volveré a comprar." },
  { name: "Dani Salama",     time: "Hace 5 años",   text: "Muy buena gente. Reconozco el oficio y la buena atención." },
  { name: "HC COBO",         time: "Hace 4 años",   text: "Excelente atención para recomendar. 10 puntos." },
  { name: "Natalio H. Pelle",time: "Hace 5 años",   text: "Excelente atención." },
  { name: "Anibal Valente",  time: "Hace 5 años",   text: "Unos fenómenos! Amigos con más de 50 años de experiencia, avalando su trabajo y seriedad." },
  { name: "Matias Viegas",   time: "Hace 5 años",   text: "Super confiable." },
];

const CLONE = 3;
const TOTAL = reviews.length;
const allItems = [...reviews.slice(-CLONE), ...reviews, ...reviews.slice(0, CLONE)];

export default function Testimonials() {
  const [idx, setIdx]         = useState(CLONE);
  const [animated, setAnimated] = useState(true);
  const [cardWidth, setCardWidth] = useState(0);
  const containerRef = useRef(null);

  /* Measure card width on mount + resize */
  useEffect(() => {
    const measure = () => {
      if (!containerRef.current) return;
      const visible = window.innerWidth >= 768 ? 3 : 1;
      setCardWidth(containerRef.current.offsetWidth / visible);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  /* Auto-advance every 5 s */
  useEffect(() => {
    const t = setInterval(() => {
      setAnimated(true);
      setIdx(i => i + 1);
    }, 5000);
    return () => clearInterval(t);
  }, []);

  /* Seamless loop: after transition ends, jump silently to real item */
  useEffect(() => {
    if (idx === CLONE + TOTAL) {
      const t = setTimeout(() => {
        setAnimated(false);
        setIdx(CLONE);
      }, 650);
      return () => clearTimeout(t);
    }
  }, [idx]);

  /* Re-enable transition after silent jump */
  useEffect(() => {
    if (!animated) {
      const id = requestAnimationFrame(() =>
        requestAnimationFrame(() => setAnimated(true))
      );
      return () => cancelAnimationFrame(id);
    }
  }, [animated]);

  const translateX = cardWidth ? -idx * cardWidth : 0;

  return (
    <section className="testimonials-section">
      <h1 className="section-title text-center font-bold py-8">TESTIMONIOS</h1>
      <p className="testimonials-subtitle">Lo que dicen nuestros clientes en Google</p>

      <div className="testimonials-outer" ref={containerRef}>
        <div
          className="testimonials-track"
          style={{
            transform:  `translateX(${translateX}px)`,
            transition: animated ? 'transform 0.65s cubic-bezier(0.25,0.46,0.45,0.94)' : 'none',
            width:      `${allItems.length * (cardWidth || 0)}px`,
          }}
        >
          {allItems.map((r, i) => (
            <div key={i} className="testimonial-card" style={{ width: cardWidth || 0 }}>
              <div className="testimonial-card-inner">
                <div className="testimonial-header">
                  <div className="testimonial-avatar" aria-hidden="true">{r.name.charAt(0)}</div>
                  <div>
                    <p className="testimonial-name">{r.name}</p>
                  </div>
                </div>
                <div className="testimonial-stars" aria-label="5 estrellas">★★★★★</div>
                <p className="testimonial-text">"{r.text}"</p>
                <p className="testimonial-time">{r.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
